$.validator.addMethod( 'enable_maxsize', function( value, element, param ) {
	if ( this.optional( element ) ) {
		return true;
	}

	if ( $( element ).attr( 'type' ) === 'file' ) {
		if ( element.files && element.files.length ) {
			for ( var i = 0; i < element.files.length; i++ ) {
				if ( element.files[ i ].size > (1048576 * param) ) {
					return false;
				}
			}
		}
	}

	return true;
}, $.validator.format( 'File size must not exceed {0} MB.' ) );



// WEBPACK FOOTER //
// ./scripts/autoload/_0_validation.js